import { useEffect, useRef } from 'react'

import { divisionsSelector, divisionsThunk } from '@ucheba/store/institutions/divisions'

import { FACETS_NAMES } from '@ucheba/store/institutions/divisions/constants'

import { institutionItemSelectors } from '@ucheba/store/institutions/item'

import { useRouter } from 'next/router'
import { useSelector, useDispatch } from 'react-redux'
import { TDivisionsDataFetching } from '../types'

// Получаем список подразделений из стора по нужного фасета (типа)
export const useDivisionsDataFetching: TDivisionsDataFetching = () => {
  const dispatch = useDispatch()
  const { query } = useRouter()

  const divisions = useSelector(divisionsSelector.divisions)

  const facets = useSelector(divisionsSelector.facets)

  const queryType = query?.type as string

  const currentTypeValue = Object.keys(FACETS_NAMES).find(
    (key) => FACETS_NAMES[key] === queryType
  )

  const parentTypeId = currentTypeValue || Number(facets?.[0]?.value)

  const { hasSubdivisions } = useSelector(institutionItemSelectors.currentInstitution)

  const isRender = useRef(false)

  useEffect(() => {
    if (hasSubdivisions && isRender.current) {
      dispatch(
        divisionsThunk.fetchDivisions({
          data: {
            institutionId: query.id,
            parentTypeId,
            limit: 15,
            offset: Number(query.page) > 1 ? (Number(query.page) - 1) * 15 : 0,
          },
        })
      )
    }

    isRender.current = true
  }, [dispatch, hasSubdivisions, parentTypeId, query.id, query.page])

  return divisions
}
